import React from 'react';
import { Tooltip } from '@material-ui/core';
import { VerifiedUser as VerifiedIcon, Payment as PaymentIcon, Lock as LockIcon } from '@material-ui/icons';
import styled from 'styled-components';


const BadgeRow = styled.div`
display: flex;
justify-content: center;
gap: 1rem;
flex-wrap: wrap;
margin: 1rem 0 0;
`;


const Badge = styled.div`
display: inline-flex;
align-items: center;
gap: 0.5rem;
padding: 0.4rem 0.8rem;
border: 1px solid #e5e7eb;
border-radius: 999px;
background: #ffffff;
color: #111827;
font-size: 12px;
`;


const IconWrap = styled.span`
display: inline-flex;
align-items: center;
`;


const ComplianceBadges = () => (
<BadgeRow>
<Tooltip title="PCI DSS Compliant Payment Processing">
<Badge>
<IconWrap><PaymentIcon fontSize="small" /></IconWrap>
PCI Compliant
</Badge>
</Tooltip>
<Tooltip title="256-bit TLS encryption">
<Badge>
<IconWrap><LockIcon fontSize="small" /></IconWrap>
Secure Checkout
</Badge>
</Tooltip>
<Tooltip title="Payments handled by Stripe">
<Badge>
<IconWrap><VerifiedIcon fontSize="small" /></IconWrap>
Stripe Verified
</Badge>
</Tooltip>
</BadgeRow>
);


export default ComplianceBadges;